// extracted by mini-css-extract-plugin
export var button = "_md-2";
export var card = "_md-0";
export var closeButtonContainer = "_md-3";
export var iconContainer = "_md-1";